(function() {
    'use strict';

    angular.module('doclr.components.notification', [])
        .factory('notificationService', function() {
            var addNotification = function(notification, optionsInput) {

                var applyDefaults = function(options) {
                    return angular.extend({
                        delay : 5000,
                        allowDuplicates: true
                    }, options);
                };

                var options = applyDefaults(optionsInput);
                $.notify(notification.msg, {
                    type: notification.type,
                    delay: options.delay,
                    mouse_over: 'pause',
                    placement: {
                        from: 'top',
                        align: 'center'
                    },
                    animate: {
                        enter: 'animated bounceInDown',
                        exit: 'animated bounceOutUp'
                    },
                    template: '<div data-notify="container" class="col-xs-11 alert alert-{0}" style="max-width: 600px" role="alert"><button type="button" aria-hidden="true" class="close" data-notify="dismiss">&times;</button><span data-notify="icon"></span> <span data-notify="title">{1}</span> <span data-notify="message">{2}</span><div class="progress" data-notify="progressbar"><div class="progress-bar progress-bar-{0}" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%;"></div></div><a href="{3}" target="{4}" data-notify="url"></a></div>'
                });
            };

            var service = {};

            service.showWarning = function(message, options) {
                addNotification({type: 'warning', msg: message} , options);
            };

            service.showInfo = function(message, options) {
                addNotification({type: 'info', msg: message }, options);
            };

            service.showSuccess = function(message, options) {
                addNotification({type: 'success', msg: message }, options);
            };

            service.showDanger = function(message, options) {
                addNotification({type: 'danger', msg: message }, options);
            };

            return service;
        })
        .factory('errorInterceptor', function($q, notificationService, responseErrorTranslations) {
            return {
                responseError : function(response) {
                    var defaultErrorMessage = doclrVertaal.instant('modules.notifications.defaultError') + response.status + ')';

                    if (response.status === 500) {
                        notificationService.showDanger(defaultErrorMessage);
                    } else if (response.status !== 401) {
                        if(shouldShowNotification(response)){
                            notificationService.showDanger(responseErrorTranslations[response.data.error]() || response.data.info || response.data.error || defaultErrorMessage);
                        }
                    }
                    return $q.reject(response);
                },
                request: function(config) {
                    if(!config.headers){
                        config.headers = {};
                    }
                    config.headers['D-Session-Token'] = 'PaukeslagBoem';
                    return config;
                }
            };

            function shouldShowNotification(response){
                return response.data.error &&
                    !getDisabledNotifications().includes(response.data.error);
            }

            function getDisabledNotifications(){
                return ['create.appointment.conflict'];
            }
        })
        .factory('responseErrorTranslations', function() {
            return {
                'afspraakmogelijkheid.niet.meer.beschikbaar' : () => doclrVertaal.instant('afspraakmogelijkheid.niet.meer.beschikbaar'),
                'afspraken.niet.toegankelijk.voor.patienten' : () => doclrVertaal.instant('afspraken.niet.toegankelijk.voor.patienten'),
                'afspraken.algmene.voorwaarden.niet.aanvaard' : () => doclrVertaal.instant('afspraken.algmene.voorwaarden.niet.aanvaard'),
                'afspraken.email.niet.gevalideerd' : () => doclrVertaal.instant('afspraken.email.niet.gevalideerd'),
                'typebeschikbaarheid.heeft.nog.afspraken' : () => doclrVertaal.instant('typebeschikbaarheid.heeft.nog.afspraken'),
                'typebeschikbaarheid.heeft.nog.beschikbaarheden.in.werkschema' : () => doclrVertaal.instant('typebeschikbaarheid.heeft.nog.beschikbaarheden.in.werkschema'),
                'typebeschikbaarheid.heeft.nog.beschikbaarheden.in.agenda' : () => doclrVertaal.instant('typebeschikbaarheid.heeft.nog.beschikbaarheden.in.agenda'),
                'oud.paswoord.niet.geldig' : () => doclrVertaal.instant('oud.paswoord.niet.geldig'),
                'afspraak.niet.meer.online.te.annuleren' : () => doclrVertaal.instant('afspraak.niet.meer.online.te.annuleren'),
                'afspraak.niet.gevonden' : () => doclrVertaal.instant('afspraak.niet.gevonden'),
                'token.niet.uniek' : () => doclrVertaal.instant('token.niet.uniek'),
                'token.niet.geldig' : () => doclrVertaal.instant('token.niet.geldig'),
                'leesbare.id.niet.uniek' : () => doclrVertaal.instant('leesbare.id.niet.uniek'),
                'werkschema.copy.to.is.not.empty' : () => doclrVertaal.instant('werkschema.copy.to.is.not.empty'),
            };
        })
        .config(function($httpProvider) {
            $httpProvider.interceptors.push('errorInterceptor');
        });
})();
